"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Env = exports.currentClientUUID = void 0;
var lodash_1 = __importDefault(require("lodash"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var uuid_1 = require("uuid");
var url_1 = require("./utils/url");
var CLIENT_UUID_KEY = 'DEVICE_ID';
function currentClientUUID(domain) {
    domain = domain || url_1.currentCookieDomain();
    var clientUUID = js_cookie_1.default.get(CLIENT_UUID_KEY);
    if (lodash_1.default.isEmpty(clientUUID)) {
        clientUUID = uuid_1.v1();
        js_cookie_1.default.set(CLIENT_UUID_KEY, clientUUID, {
            expires: 365 * 5,
            path: '/',
            domain: domain,
            sameSite: 'Lax',
        });
    }
    return clientUUID;
}
exports.currentClientUUID = currentClientUUID;
var Env = /** @class */ (function () {
    function Env(gConfig) {
        var _this = this;
        this.gConfig = gConfig;
        this.getClientUUID = function () {
            return currentClientUUID(_this.gConfig.CookieDomain);
        };
    }
    return Env;
}());
exports.Env = Env;
//# sourceMappingURL=env.js.map